import Policy from "./Policy";

export default function OrderPolicy() {
  return <Policy type="order" />;
}
